import { Offering } from "./offering";
import ThrowsValidationError from "common/http/throwsValidationError";
import Throttle from "common/decorators/throttle";
import HttpService from "common/http/httpService";

class OfferingService extends HttpService {

  @Throttle(1000, true)
  async listOfferings(): Promise<Offering[]> {
    const response = await this.getClient().get<Offering[]>('/settings/v1/Offerings');
    return response.data;
  }

  @ThrowsValidationError()
  async updateOffering(offering: Offering): Promise<void> {
    await this.getClient().put<Offering>(
      `/settings/v1/locations/${offering.location.id}/commodities/${offering.commodity.id}/offerings`,
      offering
    );
  }
}
const offerringService = new OfferingService();
export default offerringService;
